import * as angular from 'angular';
import {IController, IIntervalService, IScope, ITimeoutService} from 'angular';
import * as _ from "lodash";
import {DateRangeContextService} from "../../../commons/services/date-range-context.service";
import {SortType} from "../../../commons/types/sort.type";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PackingStatusType} from "../../types/packing-status.type";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";
import {DeliveriesRequestsService} from "../../services/deliveries-requests.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {FieldType} from "../../../site-preferences/types/field.type";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {AccountType} from "../../../account/types/account.type";
import {ServicesViewsStateType} from "../../types/services-views-state.type";
import {ExportType} from "../../../commons/types/export.type";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";
import {skip, Subscription, take} from "rxjs";
import {Service} from "../../models/service.model";
import {ServicesChanelService} from "../../angular/services/services-chanel.service";
import {GroupModel} from "../../../groups/models/group.model";
import {ActionReasonEnum} from "../../../action-reasons/enums/action-reason.enum";
import {
  ExportOmsOrdersTranslationsPayloadModel
} from "../../../oms/models/export-oms-orders-translations-payload.model";
import {ExportOmsOrdersTablePayloadModel} from "../../../oms/models/export-oms-orders-table-payload.model";
import {AgentTypeSelectCtrl} from "../../../agents/components/agent-type-select/agent-type-select.component";
import {AgentType} from "../../../agents/types/agent.type";
import {RouteModel} from "../../../routes/models/route.model";
import {EXPORT_CSV_SIZE_LIMIT, EXPORT_EXCEL_SIZE_LIMIT} from "../../../commons/angular/constants/commons";
import {ServiceGroupsType} from "../../types/service-groups.type";
import {ServiceStatusType} from "../../types/service-status.type";

export class DeliveriesViewCtrl implements IController {
  dateRangeTemplateType?: DateRangeTemplateType;
  from: any;
  to: any;
  serviceTypes: any;
  group: any;
  branchIds: any;
  agentBranchIds: string[];
  groupIds: string[];
  groupsBranchIds: string[];
  accountIds: any;
  serviceAreaIds: any;
  depotIds: any;
  supplyAccountIds: any;
  agentIds: any;
  teamIds: any;
  labels: any;
  tags: any;
  vehicleTypeIds: any;
  riskTypes: any;
  programTypes: any;
  inRoute: any;
  packingStatuses: PackingStatusType[];
  isPacked: any;
  timeToDeliver: string;
  dispatchQuoteTypes: string[];
  approvalStatuses: string[];
  selectedQuickFilterId: string;
  isMissingPackages: boolean;
  packagesIds: string[];
  reasonType: ActionReasonEnum[];
  configuredFieldName: string;
  configuredFieldValue: string;
  viewTableSettings: ViewSettingsModel;
  agentType: AgentType;

  public pageName: string;
  public selectedIds: any;
  public selectedRouteIds?: string[] = [];
  public selectedServices: any;
  private loadLimit: any;
  private MapLoadLimit: any;
  private mapBatchLoadLimit: number;
  private mapBatchLoadIntervalMs: number;
  private deliveriesRef: any;
  private deliveriesMapRef: any;
  private siteId: any;
  private userBranches: any;
  private sortTypesValues: any;
  private selectedSortValue: any;
  private mapServices: any;
  private mapPolygons: any;
  private totals: any;
  private isTimeSelectionDisabled: any;
  private totalsLoading: any;
  private filterConfig: any;
  private panelSettings: any;
  private uiRouterState: any;
  private infiniteScroll: any;
  private totalsIntervalRef: any;
  public blockingSearchDatesRangeLimit: number;
  public currentServicesNav: any;
  public has3plListPermission;
  public hasWorkloadPermission;
  public accountType: typeof AccountType = AccountType;
  public servicesSubscription: Subscription;
  public infiniteScrollServicesSubscription: Subscription;
  public services: Service[];
  public isLoadingServices: boolean;
  public isLoadingServicesSubscription: Subscription;
  public isInitializedServices: boolean;
  public isInitializedServicesSubscription: Subscription;
  public createdServicesSubscription: Subscription;
  public selectedRoutes: RouteModel[];
  public hasTeamsManagePermission: boolean;
  public groupOptions: ServiceGroupsType[];

  /* @ngInject */
  constructor(private $scope: IScope, private $infiniteScroll, private $deliveries, private deliveriesRequestsService: DeliveriesRequestsService,
              private deliveriesAlertsService: DeliveriesAlertsService, private bringozLoaderService: BringozLoaderService, private $state, private $log,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private splitService: SplitService, private quickFilterContextService: QuickFilterContextService,
              private confirmDialogService: ConfirmDialogService, private analyticsService: AnalyticsService, private moment,
              private dateRangeContextService: DateRangeContextService, private $timeout: ITimeoutService, private viewSettingsService: ViewSettingsService,
              private $interval: IIntervalService, private viewFilterSettingsService: ViewFilterSettingsService, private IAMPermissions, private servicesFacadeService: ServicesFacadeService,
              private servicesChanelService: ServicesChanelService, private $groups, private $translate) {
    this.blockingSearchDatesRangeLimit = this.splitService.getBlockingSearchDatesRangeLimit();
    this.pageName = this.$state.current.name;
    this.groupOptions = angular.copy(Object.values(ServiceGroupsType));
  }

  $onInit() {
    this.has3plListPermission = this.IAMPermissions.hasPermission('threePL.list');

    this.hasTeamsManagePermission = this.IAMPermissions.hasPermission('teams.manage');

    this.hasWorkloadPermission = this.IAMPermissions.hasPermission('shiftManagement.workload.service.get');
    this.currentServicesNav = 'internal';
    this.loadLimit = 30;
    this.MapLoadLimit = 1000;
    this.mapBatchLoadLimit = 100;
    this.mapBatchLoadIntervalMs = 1000;
    this.deliveriesRef = this.$deliveries();
    this.deliveriesMapRef = this.$deliveries();
    this.siteId = this.splitService.getSiteId();
    this.userBranches = this.splitService.getUserSiteBranchIds();
    this.sortTypesValues = {
      sortTimeWindow: {asc: 'notBefore,asc', desc: 'notBefore,desc'},
      sortAccountName: {asc: 'accountReference.name,asc', desc: 'accountReference.name,desc'},
      sortContactName: {asc: 'destinationContactName,asc', desc: 'destinationContactName,desc'},
      sortAgentAccountName: {asc: 'agentReference.accountName,asc', desc: 'agentReference.accountName,desc'},
      sortAgentName: {asc: 'agentReference.fullName,asc', desc: 'agentReference.fullName,desc'},
      sortEta: {asc: 'eta,asc', desc: 'eta,desc'},
      sortCreatedAt: {asc: 'createdAt,asc', desc: 'createdAt,desc'},
      sortDistance: {asc: 'distance,asc', desc: 'distance,desc'},
      sortProgress: {asc: 'serviceProgressGrade,asc', desc: 'serviceProgressGrade,desc'},
      sortLocationPickup: {asc: 'pickupAddress,asc', desc: 'pickupAddress,desc'},
      sortLocationDestination: {asc: 'destinationAddress,asc', desc: 'destinationAddress,desc'}
    };

    if (!this.tags) {
      this.tags = [];
    }

    this.selectedSortValue = undefined;
    this.selectedIds = [];
    this.selectedServices = [];
    this.mapServices = [];
    this.mapPolygons = [];
    this.totals = {};
    this.isTimeSelectionDisabled = false;
    this.totalsLoading = false;
    this.filterConfig = {
      includeFilters: [
        SiteFiltersType.dateRangeTemplateType,
        SiteFiltersType.serviceTypes,
        SiteFiltersType.branchIds,
        SiteFiltersType.groupIds,
        SiteFiltersType.accountIds,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.noArea,
        SiteFiltersType.serviceAreaPickup,
        SiteFiltersType.serviceAreaDropoff,
        SiteFiltersType.depotIds,
        SiteFiltersType.supplyAccountIds,
        SiteFiltersType.teamIds,
        SiteFiltersType.agentIds,
        SiteFiltersType.labels,
        SiteFiltersType.tags,
        SiteFiltersType.vehicleTypeIds,
        SiteFiltersType.riskTypes,
        SiteFiltersType.programTypes,
        SiteFiltersType.inRoute,
        // SiteFiltersType.packingStatuses,
        SiteFiltersType.isPacked,
        SiteFiltersType.timeToDeliver,
        SiteFiltersType.approvalStatuses,
        SiteFiltersType.dispatchQuoteTypes,
        SiteFiltersType.isMissingPackages,
        SiteFiltersType.packagesIds,
        SiteFiltersType.configuredPackageField,
        SiteFiltersType.configuredFieldName,
        SiteFiltersType.configuredFieldValue,
        SiteFiltersType.groups,
        SiteFiltersType.reasonType,
        SiteFiltersType.agentType
      ],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
        [SiteFiltersType.serviceTypes]: this.serviceTypes || [],
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.agentBranchIds]: this.agentBranchIds || [],
        [SiteFiltersType.groupIds]: this.groupIds || [],
        [SiteFiltersType.accountIds]: this.accountIds || [],
        [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds || [],
        [SiteFiltersType.depotIds]: this.depotIds || [],
        [SiteFiltersType.supplyAccountIds]: this.supplyAccountIds || [],
        [SiteFiltersType.teamIds]: this.teamIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || [],
        [SiteFiltersType.labels]: this.labels || [],
        [SiteFiltersType.tags]: this.tags || [],
        [SiteFiltersType.vehicleTypeIds]: this.vehicleTypeIds || [],
        [SiteFiltersType.riskTypes]: this.riskTypes || [],
        [SiteFiltersType.programTypes]: this.programTypes || [],
        [SiteFiltersType.inRoute]: this.inRoute,
        // [SiteFiltersType.packingStatuses]: this.packingStatuses || [],
        [SiteFiltersType.isPacked]: this.isPacked,
        [SiteFiltersType.dispatchQuoteTypes]: this.dispatchQuoteTypes || [],
        [SiteFiltersType.timeToDeliver]: this.timeToDeliver || undefined,
        [SiteFiltersType.approvalStatuses]: this.approvalStatuses || [],
        [SiteFiltersType.noArea]: undefined,
        [SiteFiltersType.noPickUpArea]: undefined,
        [SiteFiltersType.noDropOffArea]: undefined,
        [SiteFiltersType.isMissingPackages]: this.isMissingPackages,
        [SiteFiltersType.packagesIds]: this.packagesIds || [],
        [SiteFiltersType.configuredFieldName]: this.configuredFieldName || undefined,
        [SiteFiltersType.configuredFieldValue]: this.configuredFieldValue || undefined,
        [SiteFiltersType.groups]: [],
        [SiteFiltersType.reasonType]: this.reasonType || [],
        [SiteFiltersType.agentType]: this.agentType
      },
      excludeIdsMap: {
        [SiteFiltersType.branchIds]: this.groupsBranchIds || []
      },
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today(),
      rangeLimit: {
        min: !this.blockingSearchDatesRangeLimit ? undefined : this.moment().subtract(this.blockingSearchDatesRangeLimit, 'day').startOf('day').valueOf(),
        max: undefined,
      },
      queryString: undefined,
      siteId: this.siteId,
      deliveriesSettings: this.splitService.getSiteDeliverySettings(this.siteId),
      queryMap: {
        supplierType: this.accountType.BusinessSupply
      }
    };

    if (this.splitService.getExposeAgentBranchesOnTheService()) {
      this.filterConfig.includeFilters.push(SiteFiltersType.agentBranchIds)
    }

    this.filterConfig.deliveriesSettings.sort = {
      sortAccountName: undefined,
      sortDistance: undefined,
      // sortContactName: undefined,
      sortAgentName: undefined,
      sortTimeWindow: undefined,
      sortEta: undefined,
      sortCreatedAt: undefined,
      sortProgress: undefined
    }


    this.panelSettings = {
      agents: false,
      routes: false
    }

    this.uiRouterState = this.$state;

    const dateStart = this.moment(this.from).format("MM/DD/YYYY"),
      dateEnd = this.moment(this.to).format("MM/DD/YYYY");

    this.isTimeSelectionDisabled = !_.isEqual(dateStart, dateEnd);

    this.totals = {
      aborted: 0,
      active: 0,
      assigned: 0,
      canceled: 0,
      completed: 0,
      finished: 0,
      late: 0,
      started: 0,
      total: 0,
      unAssigned: 0,
      risk: 0,
      packed: 0,
      notPacked: 0
    };

    if (_.get(this.filterConfig, 'deliveriesSettings.sortTimeWindow')) {
      this.selectedSortValue = {
        name: 'sortTimeWindow',
        type: this.filterConfig.deliveriesSettings.sortTimeWindow,
        value: this.sortTypesValues.sortTimeWindow[this.filterConfig.deliveriesSettings.sortTimeWindow]
      }
    }

    // this.viewFilterSettingsService.setServiceAreaIds(this.serviceAreaIds);
    // this.viewFilterSettingsService.setBranchIds(this.branchIds);
    // this.viewFilterSettingsService.setAccountIds(this.accountIds);

    this._getServices();
    this.servicesFacadeService.subscribeToChannels();

    this.servicesSubscription = this.servicesFacadeService.selectAll().subscribe(services => {

      this.mapServices = this._filterServices(
        services,
        this.filterConfig.queryString,
        this.filterConfig.range.dateStart,
        this.filterConfig.range.dateEnd,
        this.filterConfig.bringozFilters.depotIds,
        this.filterConfig.bringozFilters.accountIds,
        this.filterConfig.bringozFilters.serviceAreaIds,
        this.filterConfig.bringozFilters.labels,
        this.filterConfig.bringozFilters.tags,
        this.filterConfig.bringozFilters.vehicleTypeIds,
        this.filterConfig.bringozFilters.riskTypes,
        this.filterConfig.bringozFilters.supplyAccountIds,
        this.filterConfig.bringozFilters.agentIds,
        this.filterConfig.bringozFilters.inRoute,
        this.filterConfig.bringozFilters.isPacked,
        this.filterConfig.bringozFilters.serviceTypes,
        this.filterConfig.bringozFilters.branchIds,
        this.filterConfig.bringozFilters.timeToDeliver,
        this.userBranches,
        this.filterConfig.bringozFilters.approvalStatuses,
        this.filterConfig.bringozFilters.dispatchQuoteTypes,
        this.filterConfig.bringozFilters.isMissingPackages,
        this.filterConfig.bringozFilters.packingStatuses,
        this.filterConfig.bringozFilters.packagesIds,
        this.filterConfig.bringozFilters.configuredFieldName,
        this.filterConfig.bringozFilters.configuredFieldValue,
        this.filterConfig.bringozFilters.agentBranchIds,
        this.filterConfig.bringozFilters.reasonType,
        this.filterConfig.bringozFilters.agentType
      );

      const group = _.includes(this.groupOptions, this.group) ?
        this.group :
        undefined;

      if (!_.isUndefined(group)) {
        const servicesToRemove = [];

        _.forEach(services, (s) => {
          if (group === ServiceGroupsType.Risk && !s.risk) {
            servicesToRemove.push(s);
          } else if (group !== ServiceGroupsType.Risk && !(s.status === group ||
            (s.status === ServiceStatusType.ManualHandled) && (group === ServiceGroupsType.ManualCompleted) ||
            (s.status === ServiceStatusType.Aborted) && (group === ServiceStatusType.Started))) {
            servicesToRemove.push(s);
          }
        })

        if (servicesToRemove.length) {
          const servicesToRemoveIds = servicesToRemove.map(s => s.id);
          this.mapServices = this.mapServices.filter(s => !servicesToRemoveIds.includes(s.id));
        }

      }
      this.$timeout(() => {
      }, 0)


    })

    this.infiniteScrollServicesSubscription = this.servicesFacadeService.selectInfiniteScrollEntities().subscribe((services: Service[]) => {

      this.services = this._filterServices(
        services,
        this.filterConfig.queryString,
        this.filterConfig.range.dateStart,
        this.filterConfig.range.dateEnd,
        this.filterConfig.bringozFilters.depotIds,
        this.filterConfig.bringozFilters.accountIds,
        this.filterConfig.bringozFilters.serviceAreaIds,
        this.filterConfig.bringozFilters.labels,
        this.filterConfig.bringozFilters.tags,
        this.filterConfig.bringozFilters.vehicleTypeIds,
        this.filterConfig.bringozFilters.riskTypes,
        this.filterConfig.bringozFilters.supplyAccountIds,
        this.filterConfig.bringozFilters.agentIds,
        this.filterConfig.bringozFilters.inRoute,
        this.filterConfig.bringozFilters.isPacked,
        this.filterConfig.bringozFilters.serviceTypes,
        this.filterConfig.bringozFilters.branchIds,
        this.filterConfig.bringozFilters.timeToDeliver,
        this.userBranches,
        this.filterConfig.bringozFilters.approvalStatuses,
        this.filterConfig.bringozFilters.dispatchQuoteTypes,
        this.filterConfig.bringozFilters.isMissingPackages,
        this.filterConfig.bringozFilters.packingStatuses,
        this.filterConfig.bringozFilters.packagesIds,
        this.filterConfig.bringozFilters.configuredFieldName,
        this.filterConfig.bringozFilters.configuredFieldValue,
        this.filterConfig.bringozFilters.agentBranchIds,
        this.filterConfig.bringozFilters.reasonType,
        this.filterConfig.bringozFilters.agentType
      );

      const group = _.includes(this.groupOptions, this.group) ?
        this.group :
        undefined;

      if (!_.isUndefined(group)) {
        const servicesToRemove = [];

        _.forEach(services, (s) => {
          if (group === ServiceGroupsType.Risk && !s.risk) {
            servicesToRemove.push(s);
          } else if (group !== ServiceGroupsType.Risk && !(s.status === group ||
            (s.status === ServiceStatusType.ManualHandled) && (group === ServiceGroupsType.ManualCompleted) ||
            (s.status === ServiceStatusType.Aborted) && (group === ServiceGroupsType.Started))) {
            servicesToRemove.push(s);
          }
        })

        if (servicesToRemove.length) {
          const servicesToRemoveIds = servicesToRemove.map(s => s.id);
          this.services = this.services.filter(s => !servicesToRemoveIds.includes(s.id));
        }

      }
      this.$timeout(() => {
      }, 0)
    });

    this.isLoadingServicesSubscription = this.servicesFacadeService.selectIsLoading().subscribe((isLoading) => {
      this.isLoadingServices = isLoading;
      this.$timeout(() => {
      }, 0)
    });

    this.isInitializedServicesSubscription = this.servicesFacadeService.selectInitialized().subscribe((initialized) => {
      this.isInitializedServices = initialized;
      this.$timeout(() => {
      }, 0)
    });

    ///////////////////////


    this.analyticsService.trackEvent('Deliveries View', '$onInit');
    this.loadTotals();
    const totalsTimeInterval = +(_.get(this.filterConfig, 'deliveriesSettings.totalsTimeInterval'));
    this.setTotalsIntervalRef(totalsTimeInterval);

    // Services Create Event
    this.createdServicesSubscription = this.servicesChanelService.subscribeCreateChannel().pipe(skip(1))
      .subscribe((services: Service[]) => {
        //if it's not already in the map
        const newServices = _.filter(services, (s) => {
          return !_.includes(this.services.map(s => s.id), s.id)
        })

        let filteredServices = this._filterServices(
          newServices,
          this.filterConfig.queryString,
          this.filterConfig.range.dateStart,
          this.filterConfig.range.dateEnd,
          this.filterConfig.bringozFilters.depotIds,
          this.filterConfig.bringozFilters.accountIds,
          this.filterConfig.bringozFilters.serviceAreaIds,
          this.filterConfig.bringozFilters.labels,
          this.filterConfig.bringozFilters.tags,
          this.filterConfig.bringozFilters.vehicleTypeIds,
          this.filterConfig.bringozFilters.riskTypes,
          this.filterConfig.bringozFilters.supplyAccountIds,
          this.filterConfig.bringozFilters.agentIds,
          this.filterConfig.bringozFilters.inRoute,
          this.filterConfig.bringozFilters.isPacked,
          this.filterConfig.bringozFilters.serviceTypes,
          this.filterConfig.bringozFilters.branchIds,
          this.filterConfig.bringozFilters.timeToDeliver,
          this.userBranches,
          this.filterConfig.bringozFilters.approvalStatuses,
          this.filterConfig.bringozFilters.dispatchQuoteTypes,
          this.filterConfig.bringozFilters.isMissingPackages,
          this.filterConfig.bringozFilters.packingStatuses,
          this.filterConfig.bringozFilters.packagesIds,
          this.filterConfig.bringozFilters.configuredFieldName,
          this.filterConfig.bringozFilters.configuredFieldValue,
          this.filterConfig.bringozFilters.agentBranchIds,
          this.filterConfig.bringozFilters.reasonType,
          this.filterConfig.bringozFilters.agentType
        );

        if (!filteredServices.length) return;

        const group = _.includes(this.groupOptions, this.group) ?
          this.group :
          undefined;

        if (!_.isUndefined(group)) {
          filteredServices = filteredServices.filter(s => {
            if (!(group === ServiceGroupsType.Risk && !s.risk || (group !== ServiceGroupsType.Risk && !(s.status === group ||
              (s.status === ServiceStatusType.ManualHandled) && (group === ServiceGroupsType.ManualCompleted) ||
              (s.status === ServiceStatusType.Aborted) && (group === ServiceStatusType.Started))))) {
              return s;
            }
          })
        }

        this.servicesFacadeService.setInfiniteScrollServices(filteredServices, true);
      })


    // Barcode Event
    this.$scope.$on('barcode-scanned', (event, barcode) => {
      this.$log.info('Scan detected, bar code is : ', barcode);
      this.filterConfig.queryString = barcode;
      this.submitQuery(barcode);
    });

    // Deliveries Change Event
    // this.deliveriesRef.$onChange(this.$scope, (deliveries) => {
    //   ////////////////////  HANDLE MAP ////////////////////
    // });

  }

  $onDestroy() {
    this.resetTotalsIntervalRef();
    this.servicesFacadeService.clearStore();
    this.servicesChanelService.unsubscribeCreateChannel();
    this.servicesSubscription.unsubscribe();
    this.infiniteScrollServicesSubscription.unsubscribe();
    this.isLoadingServicesSubscription.unsubscribe();
    this.isInitializedServicesSubscription.unsubscribe();
    this.createdServicesSubscription.unsubscribe();
  }

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  submitQuery(queryString) {
    this.filterConfig.queryString = queryString;
    this.analyticsService.trackEvent('Deliveries View', 'submitQuery', false);
    this._reloadDeliveries(false);
  }

  changeGroup(group) {
    this.group = group;
    this.analyticsService.trackEvent('Deliveries View', 'changeGroup', true);
    this._reloadDeliveries(true);
    this._setStateParams();
    this.analyticsService.trackEvent('Deliveries Filter', 'Status Group', group || 'Total');
  }

  onStateChangeClicked() {
    const link = this.$state.current.name === 'deliveries.map' ? '^.table' : '^.map';
    this.$state.go(link, this._getQueryParams());
    this.$timeout(0).then(() => {
    });
  }

  onToggleDriversPanel() {
    this.panelSettings = {
      agents: !this.panelSettings.agents,
      routes: false
    }
  }

  onToggleRoutesPanel() {
    this.panelSettings = {
      agents: false,
      routes: !this.panelSettings.routes
    }
  }

  onExportDeliveries(event, exportType: ExportType) {

    const totalGroup =  this.group.toLowerCase();
    const matchedKey = Object.keys(this.totals).find(
      key => key.toLowerCase() === totalGroup.toLowerCase()
    );

    const text = 'Are you sure you want to export deliveries?';
    let extraText;

    if (exportType === ExportType.Excel) {
      if (this.totals[matchedKey] > EXPORT_EXCEL_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export Deliveries to File', text, extraText, {x: EXPORT_EXCEL_SIZE_LIMIT}, event)
        .then(() => {
          this.analyticsService.trackEvent('Deliveries Actions', 'Export', 'Confirm');
          this._exportDeliveries(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
          this.analyticsService.trackEvent('Deliveries Actions', 'Export', 'Cancel');
        });
    } else if (ExportType.CSV) {
      if (this.totals[matchedKey] > EXPORT_CSV_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export Deliveries to File', text, extraText, {x: EXPORT_CSV_SIZE_LIMIT}, event)
        .then(() => {
          this.analyticsService.trackEvent('Deliveries Actions', 'Export', 'Confirm');
          this._exportDeliveries(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
          this.analyticsService.trackEvent('Deliveries Actions', 'Export', 'Cancel');
        });
    }
  }

  onMobileFiltersChange(serviceTypes, branchIds, depotIds, accountIds,
                        supplyAccountIds, agentIds, serviceAreaIds, labels,
                        tags, riskTypes, inRoute, isPacked, packingStatuses: PackingStatusType[]) {
    const filters = {
      serviceTypes: serviceTypes,
      branchIds: branchIds,
      depotIds: depotIds,
      accountIds: accountIds,
      supplyAccountIds: supplyAccountIds,
      agentIds: agentIds,
      serviceAreaIds: serviceAreaIds,
      labels: labels,
      tags: tags,
      riskTypes: riskTypes,
      inRoute: inRoute,
      isPacked: isPacked,
      packingStatuses: packingStatuses

    }
    this.onFiltersChange(filters);
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      if (quickFilter.settings.groupIds?.length) {
        this.$groups().$asyncValues(quickFilter.settings.groupIds)
          .then((groups) => {
            let groupsBranchIds = [];
            groups.forEach((g: GroupModel) => {
              if (g.branchIds?.length) {
                groupsBranchIds = groupsBranchIds.concat(g.branchIds)
              }
            });
            this.filterConfig.excludeIdsMap[SiteFiltersType.branchIds] = groupsBranchIds;
            quickFilter.settings[SiteFiltersType.branchIds] = _.uniq(groupsBranchIds);
            this.onFiltersChange(quickFilter.settings, quickFilter);
          })
      } else {
        this.onFiltersChange(quickFilter.settings, quickFilter);
      }
    } else {
      const filters = angular.copy(this.filterConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {

    // Set Filters
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    _.forOwn(filters, (value, key) => {
      if (!_.isEqual(this.filterConfig.bringozFilters[key], value)) {
        this.filterConfig.bringozFilters[key] = value;
      }
    })

    // this.filterConfig.bringozFilters = filters;

    if (!!filters.dateRangeTemplateType) {
      this.filterConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this.analyticsService.trackEvent('Deliveries View', 'onFiltersChange', true);

    // Reload deliveries by the new query
    this._reloadDeliveries(true);

    // Set query params for the view
    this._setStateParams();
  }

  onViewSettingsChange(settings) {

    if (this.pageName === ServicesViewsStateType.DELIVERIES_TABLE_STATE) {
      this._updateViewTableSettings(settings.columns);
    } else {
      this._updateViewTableSettings(settings.mapColumns);
    }

    var currentTimeWindowSortValue = _.isEqual(_.get(this.selectedSortValue, 'name'), 'sortTimeWindow') ? _.get(this.selectedSortValue, 'type') : undefined;
    var hasSortTimeWindowChanged = !_.isEqual(
      _.get(settings, 'sortTimeWindow'),
      currentTimeWindowSortValue
    );

    this.filterConfig.deliveriesSettings = settings;

    if (hasSortTimeWindowChanged) {
      this.onSortTypeChange('sortTimeWindow');
    }

    this.splitService.setSiteDeliverySettings(settings, this.siteId);
    this.deliveriesAlertsService.viewSettingsSuccess();

    this.analyticsService.trackEvent('Deliveries View', 'onViewSettingsChange');
    this.loadTotals();
    const totalsTimeInterval = +(_.get(this.filterConfig, 'deliveriesSettings.totalsTimeInterval', 0));
    if (this.totalsIntervalRef) {
      this.resetTotalsIntervalRef();
    }
    this.setTotalsIntervalRef(totalsTimeInterval);

  }

  onRangeChanged(range) {

    if (range) {
      const dateStart = this.moment(range.dateStart).format("MM/DD/YYYY"),
        dateEnd = this.moment(range.dateEnd).format("MM/DD/YYYY");

      // Disable TIME picker if its not the same date.
      this.isTimeSelectionDisabled = !_.isEqual(dateStart, dateEnd);

      // this.dateRangeContextService.setRange(range.dateStart, range.dateEnd);
    }

    if (this.selectedQuickFilterId && range?.type !== this.filterConfig.bringozFilters.dateRangeTemplateType) {
      this.selectedQuickFilterId = undefined;
    }

    this.filterConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;

    this.viewFilterSettingsService.setDateRangeTemplateType(this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type || undefined);

    this.dateRangeContextService.setRange(range.dateStart, range.dateEnd);

    this._changeRange(range);
    this._setStateParams();
  }

  onTimeSelect(range) {
    this.dateRangeContextService.setRange(range.dateStart, range.dateEnd);
    this._changeRange(range)
  }

  selectedIdsChanged(selectedIds) {
    this.selectedIds = angular.copy(selectedIds);
    this.servicesFacadeService.selectByIds(selectedIds).pipe(take(1)).subscribe(services => {
      this.selectedServices = services;
      this.$timeout(() => {
      }, 0);
    });
  }

  selectedServicesMapChanged(selectedServices) {
    if (!!selectedServices?.length) {
      this.servicesFacadeService.setInfiniteScrollServices(selectedServices, true);
      this.selectedIds = selectedServices.map(s => s.id);
      this.selectedServices = selectedServices
    } else {
      this.selectedIds = [];
      this.selectedServices = [];
    }
  }

  selectedRoutesChange(selectedRoutes) {
    this.selectedRoutes = selectedRoutes;
    this.selectedRouteIds = selectedRoutes.map(r => r.id);
  }

  getDeliveriesByMapQuery() {
    this.servicesFacadeService.getMapServicesInBatches(
      this._getQueryWithLimitPayload(this.mapBatchLoadLimit),
      true,
      this.mapBatchLoadLimit,
      this.MapLoadLimit,
      this.mapBatchLoadIntervalMs
    );
  }

  addServicesFromMap(selectedServices: Service[]) {
    if (!!selectedServices?.length) {
      this.servicesFacadeService.setInfiniteScrollServices(selectedServices, true);
    }
  }

  onActionComplete(hasStatusChanged) {
    this.onClearSelectedIds();
    if (hasStatusChanged) {
      this.analyticsService.trackEvent('Deliveries View', 'onActionComplete');
      this.loadTotals();
    }
  }

  onClearSelectedIds() {
    this.selectedIds = [];
    this.selectedServices = [];
    this.selectedRouteIds = [];
  }

  onSortTypeChange(sortName) {
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    this.analyticsService.trackEvent('Deliveries View', 'onSortTypeChange', false);
    this._reloadDeliveries(false);
  }

  onFilterByType(type, value) {
    const filterConfigBringozFilterCopy = angular.copy(this.filterConfig.bringozFilters);
    if (_.isArray(filterConfigBringozFilterCopy[type])) {
      if (_.isArray(value)) {
        filterConfigBringozFilterCopy[type] = _.uniq(filterConfigBringozFilterCopy[type].concat(value));
      } else {
        if (!_.includes(filterConfigBringozFilterCopy[type], value)) {
          filterConfigBringozFilterCopy[type].push(value);
        }
      }
    } else {
      filterConfigBringozFilterCopy[type] = value;
    }

    this.filterConfig.bringozFilters = filterConfigBringozFilterCopy;
    this._setStateParams();
    this._reloadDeliveries(true);
  }

  fetchNext() {
    if (this.isLoadingServices) return;
    this.servicesFacadeService.fetchNext(this._getQueryWithLimitPayload(this.loadLimit), true);
  }

  // **************************
  //      Private methods
  // **************************

  private _getServices() {
    this.servicesFacadeService.clearStore();
    this.servicesFacadeService.getInfiniteScrollEntities(this._getQueryWithLimitPayload(this.loadLimit), true);
  }


  private _updateViewTableSettings(columns: {}) {
    const settings = {};

    for (const key in columns) {
      settings[key] = columns[key] ? 1 : 0;
    }

    if (this.viewTableSettings) {
      const viewTableSettingsCopy = {...this.viewTableSettings, settings: settings};
      viewTableSettingsCopy.holderType = ViewSettingsHolderType.User;

      this.viewSettingsService.updateByUser(this.viewTableSettings.id, viewTableSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewTableSettings = viewSettingsTable
        })

    } else {
      const viewTableSettings = {
        pageName: this.pageName,
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.ViewTable,
        settings: settings
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewTableSettings = viewSettingsTable
        })
    }

  }

  private _exportDeliveries(type) {
    this.bringozLoaderService.on();

    const payload = {
      fieldTranslationMap: this._getExportTablePayload(),
      fieldsMap: this._getExportFieldsMapPayload(),
      metaDataMap: this._getExportMetadataMapPayload()
    };

    const group = _.includes(this.groupOptions, this.group) ?
      this.group :
      undefined;

    this.deliveriesRequestsService.exportDeliveries(
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      group,
      this.filterConfig.bringozFilters.serviceTypes,
      this.filterConfig.bringozFilters.branchIds,
      this.filterConfig.bringozFilters.depotIds,
      this.filterConfig.bringozFilters.accountIds,
      this.filterConfig.bringozFilters.supplyAccountIds,
      this.filterConfig.bringozFilters.agentIds,
      this.filterConfig.queryString,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.bringozFilters.noArea,
      this.filterConfig.bringozFilters.noPickUpArea,
      this.filterConfig.bringozFilters.noDropOffArea,
      this.filterConfig.bringozFilters.timeToDeliver === 'beforeTimeWindow' || undefined,
      this.filterConfig.bringozFilters.timeToDeliver === 'afterTimeWindow' || undefined,
      this.filterConfig.bringozFilters.inRoute,
      this.filterConfig.bringozFilters.isPacked,
      this.filterConfig.bringozFilters.packingStatuses,
      this.filterConfig.bringozFilters.labels,
      this.filterConfig.bringozFilters.tags,
      this.filterConfig.bringozFilters.vehicleTypeIds,
      this.filterConfig.bringozFilters.riskTypes,
      type,
      this.filterConfig.bringozFilters.approvalStatuses,
      this.filterConfig.bringozFilters.dispatchQuoteTypes,
      this.filterConfig.bringozFilters.programTypes,
      this.filterConfig.bringozFilters.isMissingPackages,
      this.filterConfig.bringozFilters.packagesIds,
      this.filterConfig.bringozFilters.configuredFieldName,
      this.filterConfig.bringozFilters.configuredFieldValue,
      this.filterConfig.bringozFilters.agentBranchIds,
      this.filterConfig.bringozFilters.reasonType,
      this.filterConfig.bringozFilters.agentType,
      payload,
      this.filterConfig.bringozFilters.teamIds
    )
      .then(() => {
        this.deliveriesAlertsService.exportSuccess();
      })
      .catch((error) => {
        this.deliveriesAlertsService.exportError();
        this.$log.error('Failed to export deliveries', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _getExportTablePayload() {
    return {
      deliveryId: this.$translate.instant('EXPORT_SERVICES_COLUMNS.deliveryId'),
      proNumber: this.$translate.instant('EXPORT_SERVICES_COLUMNS.proNumber'),
      pallets: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pallets'),
      externalId: this.$translate.instant('EXPORT_SERVICES_COLUMNS.externalId'),
      accountName: this.$translate.instant('EXPORT_SERVICES_COLUMNS.accountName'),
      driverName: this.$translate.instant('EXPORT_SERVICES_COLUMNS.driverName'),
      numberPackageItems: this.$translate.instant('EXPORT_SERVICES_COLUMNS.numberPackageItems'),
      status: this.$translate.instant('EXPORT_SERVICES_COLUMNS.status'),
      startTime: this.$translate.instant('EXPORT_SERVICES_COLUMNS.startTime'),
      endTime: this.$translate.instant('EXPORT_SERVICES_COLUMNS.endTime'),
      pickupAddress: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupAddress'),
      pickupAddressOne: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupAddressOne'),
      pickupAddressTwo: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupAddressTwo'),
      pickupStreet: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupStreet'),
      pickupHouse: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupHouse'),
      pickupEntrance: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupEntrance'),
      pickupFloor: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupFloor'),
      pickupApt: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupApt'),
      pickupCity: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupCity'),
      pickupZipCode: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupZipCode'),
      pickupCountry: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupCountry'),
      pickupPhone: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupPhone'),
      dropoffAddress: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffAddress'),
      dropoffAddressOne: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffAddressOne'),
      dropoffAddressTwo: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffAddressTwo'),
      dropoffStreet: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffStreet'),
      dropoffHouse: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffHouse'),
      dropoffEntrance: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffEntrance'),
      dropoffFloor: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffFloor'),
      dropoffApt: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffApt'),
      dropoffCity: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffCity'),
      dropoffZipCode: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffZipCode'),
      dropoffCountry: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffCountry'),
      dropoffPhone: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffPhone'),
      pickupContact: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupContact'),
      dropoffContact: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffContact'),
      createdTime: this.$translate.instant('EXPORT_SERVICES_COLUMNS.createdTime'),
      distance: this.$translate.instant('EXPORT_SERVICES_COLUMNS.distance'),
      totalWeight: this.$translate.instant('EXPORT_SERVICES_COLUMNS.totalWeight'),
      totalCube: this.$translate.instant('EXPORT_SERVICES_COLUMNS.totalCube'),
      agentComment: this.$translate.instant('EXPORT_SERVICES_COLUMNS.agentComment'),
      notes: this.$translate.instant('EXPORT_SERVICES_COLUMNS.notes'),
      mhNote: this.$translate.instant('EXPORT_SERVICES_COLUMNS.mhNote'),
      dropoffExtraInfo: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffExtraInfo'),
      serviceType: this.$translate.instant('EXPORT_SERVICES_COLUMNS.serviceType'),
      price: this.$translate.instant('EXPORT_SERVICES_COLUMNS.price'),
      courierPrice: this.$translate.instant('EXPORT_SERVICES_COLUMNS.courierPrice'),
      omsOrderExternalId: this.$translate.instant('EXPORT_SERVICES_COLUMNS.omsOrderExternalId'),
      programName: this.$translate.instant('EXPORT_SERVICES_COLUMNS.programName'),
      cancelReason: this.$translate.instant('EXPORT_SERVICES_COLUMNS.cancelReason'),
      lastActionTime: this.$translate.instant('EXPORT_SERVICES_COLUMNS.lastActionTime'),
      itemBarcodes: this.$translate.instant('EXPORT_SERVICES_COLUMNS.itemBarcodes'),
      packagesInfo: this.$translate.instant('EXPORT_SERVICES_COLUMNS.packagesInfo'),
      tags: this.$translate.instant('EXPORT_SERVICES_COLUMNS.tags'),
      routeId: this.$translate.instant('EXPORT_SERVICES_COLUMNS.routeId'),
      branchNames: this.$translate.instant('EXPORT_SERVICES_COLUMNS.branchNames'),
      creatorName: this.$translate.instant('EXPORT_SERVICES_COLUMNS.creatorName'),
      resourceName: this.$translate.instant('EXPORT_SERVICES_COLUMNS.resourceName'),
      pickupServiceAreaIds: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupServiceAreaIds'),
      dropoffServiceAreaIds: this.$translate.instant('EXPORT_SERVICES_COLUMNS.dropoffServiceAreaIds'),
      fieldServiceAreaIds: this.$translate.instant('EXPORT_SERVICES_COLUMNS.fieldServiceAreaIds'),
      pickupLat: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupLat'),
      pickupLng: this.$translate.instant('EXPORT_SERVICES_COLUMNS.pickupLng'),
      servicePrice: this.$translate.instant('EXPORT_SERVICES_COLUMNS.servicePrice'),
      agentCommission: this.$translate.instant('EXPORT_SERVICES_COLUMNS.agentCommission'),
      agentExpenses: this.$translate.instant('EXPORT_SERVICES_COLUMNS.agentExpenses'),
      contractPrice: this.$translate.instant('EXPORT_SERVICES_COLUMNS.contractPrice'),
      itemsIds: this.$translate.instant('EXPORT_SERVICES_COLUMNS.itemsIds'),
      assignedDate: this.$translate.instant('EXPORT_SERVICES_COLUMNS.assignedDate')
    }
  }

  private _getExportFieldsMapPayload() {
    const columns = this.uiRouterState.current.name === 'deliveries.map' ?
      this.filterConfig.deliveriesSettings.mapColumns :
      this.filterConfig.deliveriesSettings.columns;

    return {
      deliveryId: true,
      routeId: !!columns.routeId,
      externalId: true,
      accountName: !!columns.account,
      driverName: !!columns.agent,
      proNumber: !!columns.proNumber,
      numberPackageItems: true,
      status: true,
      startTime: !!columns.timeWindow,
      pallets: !!columns?.pallets,
      endTime: !!columns.timeWindow,
      pickupAddress: !!columns.location,
      pickupAddressOne: !!columns.location,
      pickupAddressTwo: !!columns.location,
      pickupStreet: !!columns.location,
      pickupHouse: !!columns.location,
      pickupEntrance: !!columns.location,
      pickupFloor: !!columns.location,
      pickupApt: !!columns.location,
      pickupCity: !!columns.location,
      pickupZipCode: !!columns.location,
      pickupCountry: !!columns.location,
      pickupPhone: true,
      dropoffAddress: !!columns.location,
      dropoffAddressOne: !!columns.location,
      dropoffAddressTwo: !!columns.location,
      dropoffStreet: !!columns.location,
      dropoffHouse: !!columns.location,
      dropoffEntrance: !!columns.location,
      dropoffFloor: !!columns.location,
      dropoffApt: !!columns.location,
      dropoffCity: !!columns.location,
      dropoffZipCode: !!columns.location,
      dropoffCountry: !!columns.location,
      dropoffPhone: true,
      pickupContact: !!columns.contact,
      dropoffContact: !!columns.contact,
      createdTime: !!columns.created,
      distance: !!columns.distance,
      totalWeight: !!columns.load,
      totalCube: !!columns.load,
      agentComment: true,
      notes: !!columns.notes,
      mhNote: true,
      dropoffExtraInfo: true,
      serviceType: true,
      price: !!columns.price,
      courierPrice: !!columns.price,
      omsOrderExternalId: this.IAMPermissions.hasPermission('oms.orders.list'),
      programName: !!columns.programType,
      cancelReason: !!columns.actionReason,
      lastActionTime: true,
      itemBarcodes: !!columns.itemsBarcodes,
      packagesInfo: true,
      tags: true,
      itemsIds: !!columns.itemsIds,
      branchNames: !!columns.operationalUnits,
      creatorName: !!columns.created,
      resourceName: !!columns.resource,
      pickupServiceAreaIds: !!columns.serviceAreas,
      dropoffServiceAreaIds: !!columns.serviceAreas,
      fieldServiceAreaIds: !!columns.serviceAreas,
      pickupLat: !!columns.location,
      pickupLng: !!columns.location,
      servicePrice: !!columns.price,
      agentCommission: !!columns.price,
      agentExpenses: !!columns.price,
      contractPrice: !!columns.price,
      assignedDate: !!columns.assignedDate
    }
  }

  private _getExportMetadataMapPayload() {
    const filteredColumns = (this.filterConfig.deliveriesSettings?.dynamicColumns || []).filter((c) => {
      return !!c.enabled;
    })
    const metaDataMapPayload = _.reduce(
      filteredColumns,
      (result, column) => {
        result[column.key] = true;
        return result;
      },
      {} as Record<string, boolean>
    );
    return metaDataMapPayload;
  }

  private _changeRange(range) {
    if (!_.isUndefined(range) && (!_.isEqual(range.dateStart, this.filterConfig.range.dateStart) || !_.isEqual(range.dateEnd, this.filterConfig.range.dateEnd))) {
      this.filterConfig.range = range;
      this.analyticsService.trackEvent('Deliveries View', '_changeRange', true);
      this._reloadDeliveries(true);
      this._setStateParams();
    }
  }

  private _filterServices(services, query, from, to, depotIds, accountIds, selectedServiceAreaIds, selectedLabelNames, selectedTagNames, vehicleTypeIds,
                          selectedRiskTypes, supplyIds, agentIds, inRoute, isPacked, serviceTypes, branchIds, timeToDeliver, userBranchIds,
                          taskApprovalStatuses, dispatchQuoteTypes, isMissingPackages, packingStatuses, packagesIds, configuredFieldName, configuredFieldValue, agentBranchIds, reasonType, agentType) {
    return _.filter(services, (service) => {

      if (!service) {
        return false;
      }

      if (timeToDeliver) {
        const time = (service.status === ServiceStatusType.Completed || service.status === ServiceStatusType.Canceled || service.status === ServiceStatusType.ManualHandled) ? service.statusUpdatedAt : this.moment().valueOf(); //last update time if stopped or current time

        if ((timeToDeliver === "beforeTimeWindow" && time > service.notBefore) || (timeToDeliver === "afterTimeWindow" && time < service.notAfter)) {
          return false;
        }
      }


      const serviceBranchIds = _.get(service, 'branchIds', []);
      if (userBranchIds?.length && serviceBranchIds.length > 0 && !(!!agentIds?.length && this.hasTeamsManagePermission)) {
        const someBranchIncludes = _checkIfSomeDeliveriesIncludesByType(serviceBranchIds, userBranchIds);
        if (!someBranchIncludes) {
          return false;
        }
      }

      const serviceTasksServiceAreaIds = _.chain(service.taskList)
        .flatMap('taskSpec.address.areaIdList')
        .compact()
        .uniq()
        .value();

      const serviceActionReasonsTypes = _.chain(service.taskList)
        .flatMap('actionReasons')
        .compact()
        .uniq()
        .map((a) => a.type)
        .value();

      const serviceTasksApprovalStatuses = _.compact(_.map(service.taskList, (t) => {
        return t.taskApprovalInfo?.taskApprovalStatus;
      }));

      let hasMissingPackages;
      let servicePackageIds = [];

      if (!!service.packageList?.length) {
        hasMissingPackages = service.packageList[0].items.find(item => {
          return item.missing;
        });
        servicePackageIds = service.packageList[0].items.map(i => i.size);
      }

      return (!query || _.includes(JSON.stringify(service).toLowerCase(), query.toLowerCase())) &&
        (service.notBefore >= from && service.notBefore <= to) &&
        (!accountIds?.length || _.includes(accountIds, service.accountId)) &&
        (!selectedServiceAreaIds?.length || !!_.intersection(serviceTasksServiceAreaIds, selectedServiceAreaIds).length) &&
        (!selectedLabelNames?.length || _checkIfSomeDeliveriesIncludesByType(service.labelNames, selectedLabelNames)) &&
        (!selectedTagNames?.length || _checkIfSomeDeliveriesIncludesByType(service.tagNames, selectedTagNames)) &&
        (!vehicleTypeIds?.length || _.includes(vehicleTypeIds, _.get(service, 'mainLogisticsVehicleReference.vehicleTypeId'))) &&
        (!supplyIds?.length || _.includes(supplyIds, service.agentAccountId)) &&
        (!agentIds?.length || _.includes(agentIds, service.agentId)) &&
        (!serviceTypes?.length || _.includes(serviceTypes, service.serviceType)) &&
        (!depotIds?.length || !_.get(service, 'depotIds.length') || _.intersection(depotIds, service.depotIds).length > 0) &&
        (!taskApprovalStatuses?.length || _.intersection(serviceTasksApprovalStatuses, taskApprovalStatuses).length > 0) &&
        (!branchIds?.length || !_.get(service, 'branchIds.length') || _.intersection(branchIds, service.branchIds).length > 0) &&
        (!agentBranchIds?.length || !_.get(service, 'agentBranchIds.length') || _.intersection(agentBranchIds, service.agentBranchIds).length > 0) &&
        (!selectedRiskTypes?.length || !_.get(service, 'risks.length') || _.intersection(selectedRiskTypes, service.risks).length > 0) &&
        (!dispatchQuoteTypes?.length || _.includes(dispatchQuoteTypes, service.dispatchQuoteType)) &&
        (!packingStatuses?.length || _.includes(packingStatuses, service?.packingInfo?.status)) &&
        (!configuredFieldName || !configuredFieldValue || _checkIfPackageCustomFieldExistsAndHaveTheValue(service.packageList, configuredFieldName, configuredFieldValue)) &&
        (_.isUndefined(inRoute) || _.isEqual(inRoute, !_.isUndefined(service.routeId))) &&
        (_.isUndefined(isPacked) || _.isEqual(isPacked, service.autoGeneratedPacked)) &&
        (_.isUndefined(isMissingPackages) || _.isEqual(isMissingPackages, !_.isUndefined(hasMissingPackages))) &&
        (_.isUndefined(agentType) || _.isEqual(agentType, _.get(service, 'agentReference.agentType'))) &&
        (!packagesIds?.length || _.includes(packagesIds, servicePackageIds)) &&
        (!reasonType?.length || !!_.intersection(serviceActionReasonsTypes, reasonType).length)
    });

    function _checkIfPackageCustomFieldExistsAndHaveTheValue(packageList: any[], configuredFieldName: string, configuredFieldValue: string) {
      let hasFieldAndValue = false;
      packageList.forEach(p => {
        p.items?.forEach(i => {
          i.configuredFields?.forEach(cf => {
            if (cf.fieldName.toLowerCase().includes(configuredFieldName.toLowerCase())) {
              if (cf.type === FieldType.DropdownMultiple) {
                cf.value?.forEach(v => {
                  if (v.toLowerCase().includes(configuredFieldValue.toLowerCase())) {
                    hasFieldAndValue = true;
                  }
                })
              } else if (cf.fieldName.toLowerCase().includes(configuredFieldValue.toLowerCase())) {
                hasFieldAndValue = true;
              }
            }
          })
        })
      })
      return hasFieldAndValue;
    }

    function _checkIfSomeDeliveriesIncludesByType(typeArray, checkList) {
      if (!typeArray) {
        return true
      }
      return _.some(typeArray, function (t) {
        return _.includes(checkList, t);
      });
    }
  }

  private _loadDeliveries() {
    this.analyticsService.trackEvent('Deliveries View', '_loadDeliveries');

    if (!!this.filterConfig.queryString) {
      const diffInDays = Math.abs(this.moment().diff(this.moment(this.filterConfig.range.dateStart), 'days'));
      if (diffInDays >= 30) {
        this.analyticsService.trackEvent('Deliveries View', 'QUERY_RANGE_30+', 'Click');
      } else if (diffInDays >= 14) {
        this.analyticsService.trackEvent('Deliveries View', 'QUERY_RANGE_14-30', 'Click');
      } else if (diffInDays >= 7) {
        this.analyticsService.trackEvent('Deliveries View', 'QUERY_RANGE_7-14', 'Click');
      } else {
        this.analyticsService.trackEvent('Deliveries View', 'QUERY_RANGE_0-7', 'Click');
      }
    }

    this._getServices();

  }

  private loadTotals() {

    if (this.totalsLoading) {
      return;
    }

    this.totalsLoading = true;
    this.deliveriesRequestsService.getTotals(
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.bringozFilters.serviceTypes,
      this.filterConfig.bringozFilters.branchIds,
      this.filterConfig.bringozFilters.depotIds,
      this.filterConfig.bringozFilters.accountIds,
      this.filterConfig.bringozFilters.supplyAccountIds,
      this.filterConfig.bringozFilters.agentIds,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.bringozFilters.noArea,
      this.filterConfig.bringozFilters.noPickUpArea,
      this.filterConfig.bringozFilters.noDropOffArea,
      this.filterConfig.bringozFilters.timeToDeliver === 'beforeTimeWindow' || undefined,
      this.filterConfig.bringozFilters.timeToDeliver === 'afterTimeWindow' || undefined,
      this.filterConfig.bringozFilters.inRoute,
      this.filterConfig.bringozFilters.isPacked,
      this.filterConfig.bringozFilters.packingStatuses,
      this.filterConfig.bringozFilters.labels,
      this.filterConfig.bringozFilters.tags,
      this.filterConfig.bringozFilters.vehicleTypeIds,
      this.filterConfig.bringozFilters.riskTypes,
      this.filterConfig.bringozFilters.programTypes,
      this.filterConfig.bringozFilters.approvalStatuses,
      this.filterConfig.bringozFilters.dispatchQuoteTypes,
      this.filterConfig.bringozFilters.isMissingPackages,
      this.filterConfig.bringozFilters.packagesIds,
      this.filterConfig.bringozFilters.configuredFieldName,
      this.filterConfig.bringozFilters.configuredFieldValue,
      this.filterConfig.bringozFilters.agentBranchIds,
      this.filterConfig.bringozFilters.reasonType,
      this.filterConfig.bringozFilters.agentType,
      this.filterConfig.bringozFilters.teamIds
    )
      .then((totals) => {
        this.totals = totals;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get totals @deliveriesView@loadTotals', error);
        }
      })
      .finally(() => {
        this.totalsLoading = false;
      });
  }

  private _reloadDeliveries(loadTotals) {
    this.servicesFacadeService.clearStore();
    this._loadDeliveries();

    if (loadTotals) {
      this.loadTotals();
    }

    if (this.$state.current.name === 'deliveries.map') {
      this.getDeliveriesByMapQuery();
    } else {
      this.mapServices = [];
    }
  }

  private _getQueryWithLimitPayload(loadLimit) {

    // Patch for 1 day time slot selection
    const to = (!this.isTimeSelectionDisabled && (this.moment(this.filterConfig.range.dateEnd).minutes() === 0)) ?
      this.moment(this.filterConfig.range.dateEnd).subtract(1, 'second').valueOf() :
      this.filterConfig.range.dateEnd;

    const group = _.includes(this.groupOptions, this.group) ?
      this.group :
      undefined;

    const params = {
      from: this.filterConfig.range.dateStart,
      to: to,
      group: group,
      serviceTypes: this.filterConfig.bringozFilters.serviceTypes,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      agentBranchIds: this.filterConfig.bringozFilters.agentBranchIds,
      depotIds: this.filterConfig.bringozFilters.depotIds,
      accountIds: this.filterConfig.bringozFilters.accountIds,
      agentAccountIds: this.filterConfig.bringozFilters.supplyAccountIds,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      teamIds: this.filterConfig.bringozFilters.teamIds,
      query: this.filterConfig.queryString,
      areaIds: this.filterConfig.bringozFilters.serviceAreaIds,
      beforeTimeWindow: this.filterConfig.bringozFilters.timeToDeliver === 'beforeTimeWindow' || undefined,
      afterTimeWindow: this.filterConfig.bringozFilters.timeToDeliver === 'afterTimeWindow' || undefined,
      noArea: this.filterConfig.bringozFilters.noArea,
      noPickUpArea: this.filterConfig.bringozFilters.noPickUpArea,
      noDropOffArea: this.filterConfig.bringozFilters.noDropOffArea,
      taskApprovalStatuses: this.filterConfig.bringozFilters.approvalStatuses,
      label: this.filterConfig.bringozFilters.labels,
      tagNames: this.filterConfig.bringozFilters.tags,
      vehicleTypeIds: this.filterConfig.bringozFilters.vehicleTypeIds,
      riskTypes: this.filterConfig.bringozFilters.riskTypes,
      programType: this.filterConfig.bringozFilters.programTypes,
      inRoute: this.filterConfig.bringozFilters.inRoute,
      isPacked: this.filterConfig.bringozFilters.isPacked,
      packingStatus: this.filterConfig.bringozFilters.packingStatuses,
      dispatchQuoteType: this.filterConfig.bringozFilters.dispatchQuoteTypes,
      missingPackageItems: this.filterConfig.bringozFilters.isMissingPackages,
      packageTypes: this.filterConfig.bringozFilters.packagesIds,
      configuredFieldId: this.filterConfig.bringozFilters.configuredFieldName,
      configuredFieldValue: this.filterConfig.bringozFilters.configuredFieldValue,
      reasonType: this.filterConfig.bringozFilters.reasonType,
      agentTypes: this.filterConfig.bringozFilters.agentType,
      limit: loadLimit,
      sort: _.get(this.selectedSortValue, 'value')
    }

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;

  }

  private _setStateParams() {
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
  }


  private setTotalsIntervalRef(milliseconds: number) {
    if (!milliseconds) return;

    this.totalsIntervalRef = this.$interval(() => {
      this.analyticsService.trackEvent('Deliveries View', 'setTotalsIntervalRef');
      this.loadTotals();
    }, milliseconds);

  }


  private _getQueryParams() {
    // Patch for 1 day time slot selection
    const to = (!this.isTimeSelectionDisabled && (this.moment(this.filterConfig.range.dateEnd).minutes() === 0)) ?
      this.moment(this.filterConfig.range.dateEnd).subtract(1, 'second').valueOf() :
      this.filterConfig.range.dateEnd;

    const group = _.includes(this.groupOptions, this.group) ?
      this.group :
      undefined;

    return {
      from: this.filterConfig.range.dateStart,
      to: to,
      group: group,
      serviceTypes: this.filterConfig.bringozFilters.serviceTypes,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      groupIds: this.filterConfig.bringozFilters.groupIds,
      accountIds: this.filterConfig.bringozFilters.accountIds,
      serviceAreaIds: this.filterConfig.bringozFilters.serviceAreaIds,
      noArea: this.filterConfig.bringozFilters.noArea,
      noPickUpArea: this.filterConfig.bringozFilters.noPickUpArea,
      noDropOffArea: this.filterConfig.bringozFilters.noDropOffArea,
      beforeTimeWindow: this.filterConfig.bringozFilters.timeToDeliver === 'beforeTimeWindow' || undefined,
      afterTimeWindow: this.filterConfig.bringozFilters.timeToDeliver === 'afterTimeWindow' || undefined,
      depotIds: this.filterConfig.bringozFilters.depotIds,
      approvalStatuses: this.filterConfig.bringozFilters.approvalStatuses,
      supplyAccountIds: this.filterConfig.bringozFilters.supplyAccountIds,
      taskApprovalStatuses: this.filterConfig.bringozFilters.approvalStatuses,
      teamIds: this.filterConfig.bringozFilters.teamIds,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      labels: this.filterConfig.bringozFilters.labels,
      tags: this.filterConfig.bringozFilters.tags,
      vehicleTypeIds: this.filterConfig.bringozFilters.vehicleTypeIds,
      riskTypes: this.filterConfig.bringozFilters.riskTypes,
      programTypes: this.filterConfig.bringozFilters.programTypes,
      inRoute: this.filterConfig.bringozFilters.inRoute,
      isPacked: this.filterConfig.bringozFilters.isPacked,
      packingStatuses: this.filterConfig.bringozFilters.packingStatuses,
      dispatchQuoteTypes: this.filterConfig.bringozFilters.dispatchQuoteTypes,
      selectedQuickFilterId: this.selectedQuickFilterId,
      dateRangeTemplateType: this.filterConfig.bringozFilters.dateRangeTemplateType,
      isMissingPackages: this.filterConfig.bringozFilters.isMissingPackages,
      packagesIds: this.filterConfig.bringozFilters.packagesIds,
      configuredFieldName: this.filterConfig.bringozFilters.configuredFieldName,
      configuredFieldValue: this.filterConfig.bringozFilters.configuredFieldValue,
      agentType: this.filterConfig.bringozFilters.agentType,
      reasonType: this.filterConfig.bringozFilters.reasonType
    }
  }

  private resetTotalsIntervalRef() {
    if (this.totalsIntervalRef) {
      this.$interval.cancel(this.totalsIntervalRef);
      this.totalsIntervalRef = undefined;
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesView', {
    bindings: {
      dateRangeTemplateType: '<?',
      from: '<',
      to: '<',
      serviceTypes: '<',
      group: '<',
      branchIds: '<?',
      agentBranchIds: '<?',
      groupIds: '<?',
      groups: '<?',
      groupsBranchIds: '<',
      accountIds: '<?',
      serviceAreaIds: '<?',
      depotIds: '<?',
      supplyAccountIds: '<?',
      agentIds: '<?',
      teamIds: '<?',
      labels: '<?',
      tags: '<?',
      vehicleTypeIds: '<?',
      riskTypes: '<?',
      dispatchQuoteTypes: '<?',
      programTypes: '<?',
      approvalStatuses: '<?',
      inRoute: '<?',
      isPacked: '<?',
      packingStatuses: '<?',
      timeToDeliver: '<?',
      selectedQuickFilterId: '<?',
      isMissingPackages: '<?',
      packagesIds: '<?',
      reasonType: '<?',
      configuredFieldName: '<?',
      configuredFieldValue: '<?',
      viewTableSettings: '<?',
      agentType: '<?'
    },
    template: require('./deliveries-view.html').default,
    controller: DeliveriesViewCtrl
  });
